import React from 'react';

import { Label } from 'semantic-ui-react';
import { ResponsiveContainer, Cell, PieChart, Pie } from 'recharts';
import { numberWithCommas } from '../../utils/utils';
import HeaderInfoTooltip from '../HeaderInfoTooltip/HeaderInfoTooltip';

export const donutColors = {
  'color-0': '#577590',
  'color-1': '#43AA8B',
  'color-2': '#90BE6D',
  'color-3': '#F9C74F',
  'color-4': '#F8961E',
  'color-5': '#F3722C'
};

export const DonutBase = ({
  data: unmodifiedData,
  dataKey,
  centerTitle,
  centerCount,
  size = 160,
  legendTitle,
  innerRadius = '70%',
  startAngle = 90,
  endAngle = 450,
  legendBackground,
  legendFormatter,
  hideLegend
}) => {
  const data = unmodifiedData.map((obj, i) => {
    obj.color = obj.color || donutColors[`color-${i}`];
    return obj;
  });

  // spreading it to get a fresh copy (ie, keep 'data' immutable)
  let legendData = [...data];

  if (data && data.length > 0 && data[0].legendOrder !== undefined) {
    legendData = legendData.sort((a, b) =>
      a.legendOrder > b.legendOrder ? 1 : b.legendOrder > a.legendOrder ? -1 : 0
    );
  }
  return (
    <React.Fragment>
      <div
        className="widget-chart-box"
        style={{ height: `${size}px`, width: `${size}px` }}>
        <ResponsiveContainer width={'100%'}>
          <PieChart
            height={size}
            width={size}
            margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
            <Pie
              data={data}
              dataKey={dataKey}
              innerRadius={innerRadius}
              outerRadius="100%"
              startAngle={startAngle}
              endAngle={endAngle}
              paddingAngle={0}>
              {data &&
                data.map((entry, index) => (
                  <Cell key={index} fill={entry.color} />
                ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <div className="center-legend">
          <span>
            {centerCount} <small>{centerTitle}</small>
          </span>
        </div>
      </div>
      {!hideLegend && (
        <div className="widget-chart-legend">
          {legendTitle && (
            <h4 style={{ fontWeight: 'normal' }}>{legendTitle}</h4>
          )}
          <ul style={{ backgroundColor: legendBackground }}>
            {legendData &&
              legendData.map((category, i) => (
                <li key={i}>
                  <Label
                    circular
                    style={{ backgroundColor: category.color }}
                    empty
                  />
                  <HeaderInfoTooltip content={category.description}>
                    {typeof legendFormatter === 'function' ? (
                      legendFormatter(category)
                    ) : (
                      <span>
                        {category.name} (
                        {typeof category.value === 'number'
                          ? numberWithCommas(category.value) || 0
                          : category.value || 0}
                        )
                      </span>
                    )}
                  </HeaderInfoTooltip>
                </li>
              ))}
          </ul>
        </div>
      )}
    </React.Fragment>
  );
};

export default DonutBase;
